import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import React from 'react';

interface DisableRolesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const DisableRolesModal: React.FC<DisableRolesModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      placement="center"
      classNames={{
        header: 'p-8',
      }}
    >
      <ModalContent>
        <ModalHeader>
          <h3 className="text-xl font-semibold text-foreground">
            Are you sure you want to disable Roles & Permissions for this
            business?
          </h3>
        </ModalHeader>

        <ModalBody>
          <p className="text-default-600 leading-relaxed">
            All team members for this business will revert back to their
            original permission settings and be able to perform all actions on
            Choco.
          </p>
        </ModalBody>

        <ModalFooter className="gap-3">
          <Button
            variant="bordered"
            onPress={onClose}
            isDisabled={isLoading}
            className="flex-1"
          >
            CANCEL
          </Button>
          <Button
            color="danger"
            onPress={onConfirm}
            isLoading={isLoading}
            className="flex-1 bg-danger text-danger-foreground"
          >
            DISABLE
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
